



































import { defineComponent, ref, onMounted, useSlots, computed } from '@vue/composition-api';
import { inApp, isAndroid } from '@/kits/system';
import elementResize from 'element-resize-detector';
import urlExt from '@k/url';
import { NavBar } from '@upc/vant';
import { getKDStaBarTopHeight } from '@/utils/tools';
import { useStatusBarHeight } from '@/hooks/useStatusBarHeight';

export default defineComponent({
  name: 'Header',
  props: {
    title: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    },
    hideContent: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: ''
    }
  },
  components: {
    NavBar
  },

  setup(props, { emit }) {
    const barHeightByUrl = urlExt.getQuery('statusbarHeight');
    const from = urlExt.getQuery('from');

    const slots = useSlots();

    const onClickLeft = () => emit('left');
    const onClickRight = () => {
      if (props.disabled) return;
      emit('right');
    };

    const barHeightByHybrid = useStatusBarHeight();
    const barHeight = ref(0);
    const nativeStatusbarHeight = computed(() => {
      if (Number(barHeightByUrl)) {
        barHeight.value = Number(barHeightByUrl);
      } else {
        if (from === 'kd' || from === 'zyb') {
          getKDStaBarTopHeight().then(res => {
            barHeight.value = res;
          });
        } else if (inApp) {
          barHeight.value = barHeightByHybrid.value;
        }
      }
      return barHeight.value;
    });

    const headerBarHeight = ref(0);
    const headerBarBoxRef = ref<any>();

    const computedHeaderBarHeight = () => {
      console.log('headerBarBox height changed.');
      if (headerBarBoxRef.value) {
        const rect = headerBarBoxRef.value.getBoundingClientRect();
        headerBarHeight.value = rect.height;
        emit('headerBarHeightChange', headerBarHeight.value);
      }
    };

    onMounted(() => {
      computedHeaderBarHeight();
      const erd = elementResize();
      erd.listenTo(headerBarBoxRef.value, computedHeaderBarHeight);
    });

    return {
      slots,
      onClickLeft,
      onClickRight,
      nativeStatusbarHeight,
      headerBarBoxRef,
      headerBarHeight,
      computedHeaderBarHeight,
      isAndroid
    };
  }
});
